import {
  AccountRepository,
  AccountTicket,
  Account,
  AccountRepositoryError,
  AccountNotAuthorizedError,
  AccountId
} from '@/Domain/Account'
import { ApiClient, Api403Error, Api500Error } from '@/Domain/ApiClient'
import { AccountFactory } from '@/Domain/Account/AccountFactory'
import { AxiosAccountData } from './AxiosAccountData'

export class AxiosAccountRepository implements AccountRepository {
  private _apiClient: ApiClient
  private _accountFactory: AccountFactory<AxiosAccountData>

  constructor (apiClient: ApiClient, accountFactory: AccountFactory<AxiosAccountData>) {
    this._apiClient = apiClient
    this._accountFactory = accountFactory
  }

  async checkTicket (ticket: AccountTicket): Promise<Account> {
    try {
      const url = '/sobree/api/identity/check/' + ticket.value()
      const response = await this._apiClient.makeGetRequest(url, {})
      return this._accountFactory.makeAccount(response.data.data.account)
    } catch (error) {
      if (error instanceof Api403Error) {
        throw new AccountNotAuthorizedError(error.message)
      }
      if (error instanceof Api500Error) {
        throw new AccountRepositoryError(error.message)
      }
      return Promise.reject(error)
    }
  }

  async checkSession (accountId: AccountId): Promise<Account> {
    try {
      const url = '/sobree/api/authentication/checkToken/' + accountId.accountId() + '?tmp=' + Date.now()
      const response = await this._apiClient.makeGetRequest(url, {})
      return this._accountFactory.makeAccount(response.data.data.account)
    } catch (error) {
      if (error instanceof Api403Error) {
        throw new AccountNotAuthorizedError(error.message)
      }
      if (error instanceof Api500Error) {
        throw new AccountRepositoryError(error.message)
      }
      throw error
    }
  }
}
